import { render, staticRenderFns } from "./QuizReferencesCard.vue?vue&type=template&id=54426b4c&scoped=true"
import script from "./QuizReferencesCard.vue?vue&type=script&lang=js"
export * from "./QuizReferencesCard.vue?vue&type=script&lang=js"
import style0 from "./QuizReferencesCard.vue?vue&type=style&index=0&id=54426b4c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54426b4c",
  null
  
)

export default component.exports